module.exports = __webpack_public_path__ + "img/1081678890.a73f07e2.jpg";